/**
 * CWR 1.3 — Quick actions (mockup dashboard-mockup.html:1780–1808).
 * Three independent buttons: Chat / Waitlist / Invite Friends.
 *
 * client-chat-screen D7 (client-chat-door.html frame A2): the Chat chip reads Chat over
 * Secure chat (Gabriel 2026-10-05, so it shows whole in equal thirds), opens the chat screen, and carries the count of unread secure messages
 * from the business in its corner, hidden at zero.
 */
import { ChatIcon, ClockIcon, InviteIcon } from './icons';
import styles from '../BookingHubPage.module.css';

export interface QuickActionsProps {
  onChat: () => void;
  /** Unread secure messages from the business (the dashboard's `chatUnreadSecure`). */
  chatUnread?: number;
  onWaitlist: () => void;
  onInvite: () => void;
}

export function QuickActions({ onChat, chatUnread = 0, onWaitlist, onInvite }: QuickActionsProps) {
  const unread = Math.max(0, chatUnread);
  return (
    <div className={styles.quickActions} data-testid="home-quick-actions">
      <button
        type="button"
        className={`${styles.quickAction} ${styles.quickActionChat}`}
        onClick={onChat}
        aria-label={unread > 0 ? `Chat, secure chat, ${unread} unread` : 'Chat, secure chat'}
      >
        {unread > 0 && (
          <span className={styles.quickActionBadge} data-testid="chat-unread-badge" aria-hidden="true">
            {unread > 99 ? '99+' : unread}
          </span>
        )}
        <span className={styles.quickActionIcon}>
          <ChatIcon />
        </span>
        <span className={styles.quickActionLabel}>
          <span className={styles.quickActionTitle}>Chat</span>
          <span className={styles.quickActionSub}>Secure chat</span>
        </span>
      </button>
      <button type="button" className={styles.quickAction} onClick={onWaitlist}>
        <span className={styles.quickActionIcon}>
          <ClockIcon />
        </span>
        <span className={styles.quickActionLabel}>
          <span className={styles.quickActionTitle}>Waitlist</span>
          <span className={styles.quickActionSub}>Your position</span>
        </span>
      </button>
      <button type="button" className={styles.quickAction} onClick={onInvite}>
        <span className={styles.quickActionIcon}>
          <InviteIcon />
        </span>
        <span className={styles.quickActionLabel}>
          <span className={styles.quickActionTitle}>Invite Friends</span>
        </span>
      </button>
    </div>
  );
}
